import { render } from "./TalentDiagnosisSection.vue?vue&type=template&id=6fea4868&scoped=true"
import script from "./TalentDiagnosisSection.vue?vue&type=script&lang=js"
export * from "./TalentDiagnosisSection.vue?vue&type=script&lang=js"

import "./TalentDiagnosisSection.vue?vue&type=style&index=0&id=6fea4868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fea4868"]])

export default __exports__